import { type MouseEventData } from '../external-types';
import { type IPoint } from 'fabric/fabric-impl';
import type Canvas from '../objects/Canvas';
import MindMap from '../objects/MindMap';
import type StylusMindMap from './StylusMindMap';
import DraggableBrush from './DraggableBrush';

// Brush for drawing MindMaps
class MindMapDrawingBrush extends DraggableBrush {
  canvas: Canvas;
  stylus: StylusMindMap;
  clickStart: { pointer: IPoint };

  constructor(canvas: Canvas, stylus: StylusMindMap) {
    super();
    this.canvas = canvas;
    this.stylus = stylus;
    this.clickStart = { pointer: { x: 0, y: 0 } };
  }

  async startDragging(pointer: IPoint) {
    return this.createMindMap(pointer);
  }

  onMouseDown(pointer: IPoint, eventData: MouseEventData) {
    if (!this.canvas._isMainEvent(eventData.e)) {
      return;
    }

    this.canvas.controller.actionSetStylusMenu(null);
    this.createMindMap(pointer);
  }

  onMouseMove() {}

  onMouseUp(eventData: MouseEventData) {
    if (!this.canvas._isMainEvent(eventData.e)) {
      return true;
    }
    this.stylus.drawingComplete();
    this.canvas.controller.undoManager.completeUndoGroup();

    return false;
  }

  createMindMap(pointer: IPoint) {
    const mindmap = new MindMap({
      sides: this.stylus.sides,
      themeName: this.stylus.theme,
      controller: this.canvas.controller,
      left: pointer.x,
      top: pointer.y,
      scaleX: 1,
      scaleY: 1,
    });

    this.canvas.controller.addToCanvas(mindmap);
    return mindmap;
  }

  _render() {}
}

export default MindMapDrawingBrush;
